import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import { I18nProvider } from "@/i18n/I18nContext";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ChambresPage from "@/pages/ChambresPage";
import GitesPage from "@/pages/GitesPage";
import AccommodationDetail from "@/pages/AccommodationDetail";
import SeminairesPage from "@/pages/SeminairesPage";
import DomainePage from "@/pages/DomainePage";
import MealOrderPage from "@/pages/MealOrderPage";
import LivretPage from "@/pages/LivretPage";
import ArrivalPage from "@/pages/ArrivalPage";
import RegionPage from "@/pages/RegionPage";
import RegionDetail from "@/pages/RegionDetail";
import InfosPage from "@/pages/InfosPage";
import ContactPage from "@/pages/ContactPage";
import SearchResults from "@/pages/SearchResults";
import BookingSuccess from "@/pages/BookingSuccess";
import PackagesPage from "@/pages/PackagesPage";
import GiftCardPage from "@/pages/GiftCardPage";
import BoutiquePage from "@/pages/BoutiquePage";
import GiftCardSuccess from "@/pages/GiftCardSuccess";
import CancellationPage from "@/pages/CancellationPage";
import PrivacyPage from "@/pages/PrivacyPage";
import MentionsPage from "@/pages/MentionsPage";
import CgvPage from "@/pages/CgvPage";
import PolicePage from "@/pages/PolicePage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <I18nProvider>
      <SiteProvider>
        <AuthProvider>
          <HelmetProvider>
            <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/chambres-hotes" element={<ChambresPage />} />
                <Route path="/gites" element={<GitesPage />} />
                <Route path="/nos-sejours" element={<PackagesPage />} />
                <Route path="/cheques-cadeaux" element={<GiftCardPage />} />
                <Route path="/boutique" element={<BoutiquePage />} />
                <Route path="/cheque-cadeau/merci" element={<GiftCardSuccess />} />
                <Route path="/hebergement/:slug" element={<AccommodationDetail />} />
                <Route path="/seminaires" element={<SeminairesPage />} />
                <Route path="/le-domaine" element={<DomainePage />} />
                <Route path="/commander-repas" element={<MealOrderPage />} />
                <Route path="/la-region" element={<RegionPage />} />
                <Route path="/la-region/:slug" element={<RegionDetail />} />
                <Route path="/informations-pratiques" element={<InfosPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/disponibilites" element={<SearchResults />} />
                <Route path="/reservation/merci" element={<BookingSuccess />} />
                <Route path="/mentions-legales" element={<MentionsPage />} />
                <Route path="/confidentialite" element={<PrivacyPage />} />
                <Route path="/cgv" element={<CgvPage />} />
                <Route path="/annulation" element={<CancellationPage />} />
                <Route path="/fiche-police" element={<PolicePage />} />
                <Route path="/fiche-police/:bookingId" element={<PolicePage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/livret" element={<LivretPage />} />
              <Route path="/arrivee/:token" element={<ArrivalPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
          </HelmetProvider>
        </AuthProvider>
      </SiteProvider>
    </I18nProvider>
  );
}

export default App;
